export function TableData({content}: {content: any}) {
  return (
    <td className="!text-[13px] !font-medium !text-gray-600 !py-5 !px-3">
      {content}
    </td>
  );
}
